interface Page {
  TITLE: string;
  PATH: string;
  ACCESS: PageAccessType;
  DESCRIPTION?: string;
}

export type PageAccessType = "public" | "authenticated" | "not-authenticated";

const pages = {
  HOME: {
    TITLE: "VideoToTextAI - Transcriptions, ChatGPT for Your Video and Audio",
    PATH: "/",
    ACCESS: "public",
    DESCRIPTION:
      "AI Transcriptions, Translations, Subtitling and 'Chat with your video' software - 99% accurate, over 130 languages supported",
  },
  ABOUT: {
    TITLE: "About Us",
    PATH: "/about",
    ACCESS: "public",
    DESCRIPTION: "VideoToTextAI is the best Video To Text software out there. Get started with VideoToTextAI today.",
  },
  BLOG: {
    TITLE: "Blog",
    PATH: "https://blog.videototextai.com/",
    ACCESS: "public",
    DESCRIPTION: "Video To Text AI Blog",
  },
  FEATURES: {
    TITLE: "Features",
    PATH: "/features",
    ACCESS: "public",
    DESCRIPTION:
      "Explore the advanced features of Video To Text AI like 'Chat with your video', SRT formatting, Instant Translations, Transcriptions in over 130 languages.",
  },
  // FREE_YOUTUBE_SUBTITLES: {
  //     TITLE: 'Free Youtube Subtitles',
  //     PATH: '/tools/free-youtube-subtitles',
  //     ACCESS: 'public'
  // },
  FREE_YOUTUBE_TO_BLOG: {
    TITLE: "Youtube Video To Blog Converter",
    PATH: "/tools/youtube-to-blog",
    ACCESS: "public",
  },
  LOGIN: {
    TITLE: "Login",
    PATH: "/login",
    ACCESS: "not-authenticated",
  },
  PAYMENT_CANCELED: {
    TITLE: "Payment Canceled",
    PATH: "/payment/canceled",
    ACCESS: "authenticated",
  },
  PAYMENT_SUCCESS: {
    TITLE: "Payment Success",
    PATH: "/payment/success",
    ACCESS: "authenticated",
  },
  PRICING: {
    TITLE: "Pricing",
    PATH: "/pricing",
    ACCESS: "public",
    DESCRIPTION: "Learn more about VideoToTextAI pricing. Start testing today for free or find a plan that meets your needs.",
  },
  PRIVACY: {
    TITLE: "Privacy Policy",
    PATH: "/privacy",
    ACCESS: "public",
    DESCRIPTION: "VideoToTextAI values the privacy of our users. Learn how we collect, use and disclose information from and about you.",
  },
  SIGN_UP: {
    TITLE: "Sign Up",
    PATH: "/signup",
    ACCESS: "not-authenticated",
  },
  SUPPORT: {
    TITLE: "Support",
    PATH: "/support",
    ACCESS: "public",
    DESCRIPTION: "VideoToTextAI Support",
  },
  TERMS: {
    TITLE: "Terms of Service",
    PATH: "/terms",
    ACCESS: "public",
    DESCRIPTION: "Learn more about VideoToTextAI Terms of Service",
  },
  TOOLS: {
    TITLE: "Tools",
    PATH: "/tools",
    ACCESS: "public",
    DESCRIPTION: "Use VideoToTextAI to solve different problems",
  },
  FILES: {
    TITLE: "Files",
    PATH: "/files",
    ACCESS: "authenticated",
  },
  SOCIAL: {
    TITLE: "Social",
    PATH: "/social",
    ACCESS: "authenticated",
  },
  FILE: {
    TITLE: "File",
    PATH: "/files/:uuid_filename",
    ACCESS: "authenticated",
  },
  FILE_TEXT: {
    TITLE: "Text",
    PATH: "/files/:uuid_filename/text",
    ACCESS: "authenticated",
  },
  FILE_STUDIO: {
    TITLE: "Short-Form Studio",
    PATH: "/files/:uuid_filename/studio",
    ACCESS: "authenticated",
  },
  FILE_CAPTIONS: {
    TITLE: "Captions",
    PATH: "/files/:uuid_filename/:lang/captions",
    ACCESS: "authenticated",
  },
  FILE_AI_TOOLS: {
    TITLE: "AI Magic Tools",
    PATH: "/files/:uuid_filename/ai-tools",
    ACCESS: "authenticated",
  },
  VIDEO_TO_TEXT: {
    TITLE: "Video to Text | Choose the Right Transcript Workflow",
    PATH: "/video-to-text",
    ACCESS: "public",
    DESCRIPTION:
      "Use the generic video-to-text hub to choose the right workflow for links, uploads, social videos, meetings, podcasts, and format-specific exports.",
  },
  CHATGPT_TRANSCRIBE: {
    TITLE: "How to Transcribe Video with ChatGPT (and Why It Fails)",
    PATH: "/transcribe-video-with-chatgpt",
    ACCESS: "public",
    DESCRIPTION: "Learn why ChatGPT cannot transcribe videos directly and how to get a clean transcript fast with Video To Text AI.",
  },
  COOKING_RECIPES: {
    TITLE: "Cooking Video to Recipe converter",
    PATH: "https://blog.videototextai.com/posts/how-to-turn-any-cooking-content-into-a-recipe",
    ACCESS: "public",
  },
  VIDEO_BLOG: {
    TITLE: "Video To Blog Converter",
    PATH: "https://blog.videototextai.com/posts/how-to-use-chatgpt-to-turn-your-youtube-videos-into-blog-posts",
    ACCESS: "public",
  },
  PODCAST_TRANSCRIPTION: {
    TITLE: "Podcast Transcription",
    PATH: "/tools/podcast-transcription",
    ACCESS: "public",
    DESCRIPTION:
      "VideoToTextAI's Podcast Transcription tool is an AI service which is able to almost instantly " +
      "transcribe your podcasts into text with 99% accuracy in more than 50 languages.",
  },
  INSTAGRAM_TO_TEXT: {
    TITLE: "Instagram to Transcript",
    PATH: "/tools/instagram-to-transcript",
    ACCESS: "public",
    DESCRIPTION: "Paste an Instagram Reel link and get a clean transcript with export-ready text and captions.",
  },
  TIKTOK_TO_TRANSCRIPT: {
    TITLE: "TikTok to Transcript",
    PATH: "/tools/tiktok-to-transcript",
    ACCESS: "public",
    DESCRIPTION: "Convert TikTok videos to transcript text in seconds with AI transcription.",
  },
  INSTAGRAM_TO_COOKING_RECIPE: {
    TITLE: "Instagram Reel to Cooking Recipe",
    PATH: "/tools/instagram-to-cooking-recipe",
    ACCESS: "public",
    DESCRIPTION: "Convert Instagram cooking Reels into structured recipes with ingredients and steps.",
  },
  REEL_TO_POST_CONVERTER: {
    TITLE: "Reel to LinkedIn + Newsletter",
    PATH: "/tools/reel-to-post-converter",
    ACCESS: "public",
    DESCRIPTION: "Convert Instagram Reels into LinkedIn posts and email newsletters.",
  },
  ITINERARY_EXTRACTOR: {
    TITLE: "Travel Reel Location Extractor",
    PATH: "/tools/itinerary-extractor",
    ACCESS: "public",
    DESCRIPTION: "Extract locations mentioned in a travel Reel.",
  },
  INSTAGRAM_REEL_HOOK_EXTRACTOR: {
    TITLE: "Instagram Reel Hook Extractor",
    PATH: "/tools/instagram-reel-hook-extractor",
    ACCESS: "public",
    DESCRIPTION: "Extract viral hooks and script lines from Instagram Reels.",
  },
  INSTAGRAM_REEL_TO_LINKEDIN_POST: {
    TITLE: "Instagram Reel to LinkedIn Post",
    PATH: "/tools/instagram-reel-to-linkedin-post",
    ACCESS: "public",
    DESCRIPTION: "Turn Instagram Reels into polished LinkedIn post drafts.",
  },
  INSTAGRAM_REEL_TO_BLOG_POST: {
    TITLE: "Instagram Reel to Blog Post",
    PATH: "/tools/instagram-reel-to-blog-post",
    ACCESS: "public",
    DESCRIPTION: "Turn Instagram Reels into blog-ready draft content.",
  },
  FEEDBACK: {
    TITLE: "Feedback",
    PATH: "/support#feedback",
    ACCESS: "public",
  },
  INSTAGRAM_ANALYTICS: {
    TITLE: "Instagram Reel Analytics & Competitor Research Tool",
    PATH: "/tools/instagram-analytics",
    ACCESS: "public",
    DESCRIPTION: "Analyze Instagram Reels with AI. Get hook scores, audience insights from comments, and AI-generated creative briefs.",
  },
  RESEARCH: {
    TITLE: "Insta Analytics",
    PATH: "/research",
    ACCESS: "authenticated",
  },
} as const;

type PagesType = Record<keyof typeof pages, Page>;
export const PAGES: PagesType = pages;
